var _path, _path2, _g, _path3, _circle, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDropIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 53,
    viewBox: "0 0 70 53",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.05172 9.36841L17.2131 7.50818V41.3606L12.3018 42.3946C9.01306 43.087 5.79705 40.9433 5.17081 37.6413L1.14319 16.4048C0.515988 13.0977 2.73148 9.92178 6.05172 9.36841Z",
    fill: "white",
    stroke: "#709506",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M63.9483 9.36841L52.7869 7.50818V41.3606L57.6982 42.3946C60.9869 43.087 64.203 40.9433 64.8292 37.6413L68.8568 16.4048C69.484 13.0977 67.2685 9.92178 63.9483 9.36841Z",
    fill: "white",
    stroke: "#709506",
    strokeWidth: 2
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_dd_1227_38368)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 16.0656,
    y: 0.622925,
    width: 37.8689,
    height: 44.7541,
    rx: 6,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 17.0656,
    y: 1.62292,
    width: 35.8689,
    height: 42.7541,
    rx: 5,
    stroke: "#709506",
    strokeWidth: 2
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M47.9344 44.377H22.0655C19.3041 44.377 17.0656 42.1385 17.0656 39.377L17.0656 35.916L29.4724 22.7681L38.9825 33.712C39.7832 34.6334 41.2154 34.6289 42.0102 33.7024L47.2456 27.5994L52.9344 33.7208V39.3771C52.9344 42.1385 50.6958 44.377 47.9344 44.377Z",
    fill: "#F3F3F9",
    stroke: "#709506",
    strokeWidth: 2
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 39.5902,
    cy: 14.9672,
    r: 4.16393,
    fill: "#F3F3F9",
    stroke: "#709506",
    strokeWidth: 2
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_dd_1227_38368",
    x: 13.0656,
    y: 0.622925,
    width: 43.8689,
    height: 51.7541,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.06 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1227_38368"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.07 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_1227_38368",
    result: "effect2_dropShadow_1227_38368"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_1227_38368",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDropIcon);
export default __webpack_public_path__ + "static/media/drop-icon.c29cb145fdc02678ef804ff090c41a47.svg";
export { ForwardRef as ReactComponent };